import React       from 'react';
import ReactDom    from 'react-dom';
// -------------------------------------------------------

class InputTags extends React.Component {
  /*
   * コンストラクタ
   */
  constructor(props) {
    super(props);
    this.init(props);
  }
  // -------------------------------------------------------
  
  /*
   * ステートの設定
   */
  init(props) {
    this.state = {
      is_active: false,
    }
  }
  // -------------------------------------------------------
  
  change() {
    this.setState({ is_active: (this.item.value != '') });
  }
  // -------------------------------------------------------
  
  getTags() {
    let tags = [];
    try { tags = this.props.data.default.split(',').filter((t) => { if( t != '' ) return t; }); } catch(e) {}
    
    return tags;
  }
  // -------------------------------------------------------
  
  submit() {
    let value = this.item.value.replace('#','').replace('＃','').replace(/,/ig,'');
    if( value == '' ) return;
    
    let tags = this.getTags.bind(this)();
    if( tags.indexOf(value) == -1 ) tags.push(value);
    
    this.props.update_ev.bind(this)(tags.join());
    this.item.value = '';
    
    this.setState({ is_active: false });
  }
  // -------------------------------------------------------
  
  delete(target) {
    let tags = this.getTags.bind(this)();
    tags = tags.filter((t) => { if( t != target ) return t; });
    
    this.props.update_ev.bind(this)(tags.join());
  }
  // -------------------------------------------------------
  
  render() {
    let data = this.props.data;
    
    let tags = this.getTags.bind(this)();
    
    return (
      <div className="upload-tags">
        <ul>
          { tags.map((t, key) => {
            if( t == '' ) return null;
            return <li key={key}>{(data.id == 'must_hashtag') && '#'}{t}<i className="material-icons" onClick={this.delete.bind(this, t)}>close</i></li>
          })}
        </ul>
        
        <div className="upload-tags-form">
          <input className="text" type="text" ref={(input) => { this.item = input }} onChange={this.change.bind(this)} placeholder={data.name +'を入力してください'} />
          
          { (this.state.is_active == true)
            ? <p className="button" onClick={this.submit.bind(this)}>追加</p>
            : <p className="button off">追加</p>
          }
        </div>
      </div>
    );
  }
}
// -------------------------------------------------------

// レンダリング処理
export default InputTags;